import Pusher from 'pusher-js'
import store from './store/index.js'
import throwConfetti from './throwConfetti.js'

export default {
  connect () {
    if ( !store.state.animation ) { return }

    const pusher = new Pusher(store.state.pusher.key, {
      cluster: store.state.pusher.cluster,
      forceTLS: true
    });
    this.openChannel(pusher);
  },
  openChannel (pusher) {
    const channel = pusher.subscribe(store.state.dog.name);

    const statsUpdatedEvent = store.getters.custom('umbrella_stats') ?
      'umbrella-stats-updated' :
      'stats-updated'
    channel.bind(statsUpdatedEvent, data => {
      if ( !store.state.animation ) { return }
      store.dispatch('statsUpdated', data);
    });

    const onDonationCreated = data => {
      if ( !store.state.animation ) { return }
      store.dispatch('addDonation', data);
    };

    channel.bind('donation-created', onDonationCreated);

    // Umbrella dogs also listen for donations to their pack members
    if (store.state.dog.dog_pack_members_info?.length) {
      store.state.dog.dog_pack_members_info.filter(dog => dog.name !== store.state.dog.name).forEach(dog => {
        pusher.subscribe(dog.name).bind('donation-created', onDonationCreated);
      });
    }

    channel.bind('celebrate', data => {
      throwConfetti(data);
    });
  },
};
